module.exports = __webpack_public_path__ + "static/media/banner-music.358aef03.png";